<script setup>

import {computed} from "@vue/reactivity";
import Validation from "@/classes/global/Validation";

const labelToLeft = computed(() => setLabelToLeft());
const emit = defineEmits(['update:modelValue']);

const props = defineProps({

  modelValue: Boolean,

  styleString: {type: String},
  disabled: {type: Boolean, default: false},
  label: {type: String, default: ''},
  labelTop: {type: Boolean, default: false,},
  labelWidth: {type: Number, default: 130},
  requiredField: {type: Boolean, default: false},
  value: {type: Boolean, default: false},
  labelColor: {type: String, default: '#000'},

})

function emitResult(value){
  emit('update:modelValue', value);
}

function setLabelToLeft() {
  if (!props.labelTop) {
    return 'flex'
  }
  return '';
}

</script>

<template>
  <div id="Vue-3-component-checkbox" :style="{display: labelToLeft}" class="checkbox-wrapper">
    <div
        v-show="label.length > 0"
        :class="{'label-left' : labelToLeft === 'flex'}"
        :style="{width : labelWidth + 'px', color: labelColor}"
        :title="label">
      {{ label }}
    </div>
    <label data-cy="check-box" class="checkbox-container" :style="styleString">
      <input
          type="checkbox"
          :disabled="disabled"
          :checked="modelValue"
          @change="emitResult($event.target.checked)">
      <span class="checkbox-checkmark" :class="{'checkbox-checkmark_disabled' : props.disabled}"></span>
    </label>
  </div>
</template>

<style scoped>

.checkbox-wrapper {
  position: relative;
  /*margin-top: 2px;*/
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 13px;
}


/* Customize the label (the container) */
.checkbox-container {
  /*display: block;*/
  position: relative;
  /*padding-left: 35px;*/
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;


}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkbox-checkmark {
  position: absolute;
  top: 0;
  /*left: 0;*/
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: solid 1px #c3c3c3;
  border-radius: 4px;
}

.checkbox-checkmark_disabled {
  background: #e2e2e2;
}


/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkbox-checkmark {
  border-color: #265a87;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkbox-checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkbox-checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkbox-checkmark:after {
  left: 7px;
  top: 3px;
  width: 4px;
  height: 10px;
  border: solid #1a507a;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.checkbox-container input[type="checkbox"]:focus + .checkbox-checkmark {
  outline: none;
  border-color: #4c7bae;
  /* default chrome blue outline if ever required
  /*outline: rgb(59, 153, 252) auto 1px;*/
}

.label-left {
  padding: 5px 15px 0 0;
  color: #222222;
  display: flex;

}


</style>
